// extracted by mini-css-extract-plugin
export default {"container":"styles_container__b6-uN","label":"styles_label__404-Y","key":"styles_key__KX+q8"};